import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import riskReducer from '../../../store/reducers/riskReducer';
import { connect } from "react-redux";
import { compose } from "redux";
import {
  LineChart, Line, ResponsiveContainer, LabelList
} from 'recharts';

const AssetQuarterMetric = ({ height, data }) => {
  const { t } = useTranslation();
  // const data = [
  //   { name: 'Q1', value: 12 },
  //   { name: 'Q2', value: 15 },
  //   { name: 'Q3', value: 18 },
  //   { name: 'Q4', value: 14 },
  // ];

  const [processedData, setprocessedData] = useState([]);
  const [assetCount, setassetCount] = useState(0);
  
  useEffect(() => {
      if (data) {
        setprocessedData(data)
        setassetCount(data.reduce((total, item) => total + item.value, 0))
      }
    }, [data]);


  return (
    <div className="w-full bg-white rounded-lg px-2 flex flex-col justify-between" style={{ height }}>
      <div className="text-md font-normal text-gray-800">
        {t("assetManagement.statsPage.assetsCount", { count: assetCount })}
      </div>

      <div className="flex-1 flex items-center justify-center pt-6">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={processedData}>
            <Line
              type="monotone"
              dataKey="value"
              stroke="#05769D"
              strokeWidth={3}
              dot={{ r: 3 }}
              isAnimationActive={false}
            >
              <LabelList dataKey="value" position="bottom" offset={10} fontSize={10} />
            </Line>
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  //////console.log("Risk MEtrix data", state.dashboard)
    return {

      //token: state.auth.token,
      //departments: state.department.departments,
      //department_id: state.department.department_id
      data: state.asset.assets_stat_data.quarters
    };
};

const mapDispatchToProps = (dispatch) => {
    return {

    };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(AssetQuarterMetric);